import React, { useState } from "react";
import FileChonky from "../components/chonky/index";
import { Modal } from "antd";

import { useSelector, useDispatch } from "react-redux";
import { fileManagerActions } from "../store";
import { LocalImage } from "../components/ImageUtil";

export default function UploadFile() {
  const dispatch = useDispatch();

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  const [show, setShow] = useState(false);

  const onSelected = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
    setShow(!show);
  };
  const showWindow = () => {
    setShow(!show);
  };

  return (
    <>
      <div>
        <div style={{ cursor: "pointer" }}>
          <LocalImage src={fileImageUrl} onClick={showWindow} preview={false} style={{ objectFit: "contain" }} width={200} height={200} />
        </div>

        {show && (
          <Modal
            title=""
            visible={show}
            width={1300}
            // onOk={() => {
            //   setShow(false);
            // }}
            style={{ top: 20 }}
            okButtonProps={{
              disabled: true,
            }}
            onCancel={() => {
              setShow(false);
            }}
            destroyOnClose={true}
          >
            <div style={{ padding: "15px" }}>
              <FileChonky onSelected={onSelected} />
              <br />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
}
